<template>
<div>
    <div class="start-quiz" v-if="loaded">
        <div class="popup" v-if="popupActive">
            <div class="popup-content">
                <p>A kérdésekre időkorlát vonatkozik (20 mp és 120 mp), az idő lejártával automatikusan továbbléptetjük a következő kérdésre.</p>

                <p>A kérdések között nincs lehetőséged visszalépni az előző kérdésre, ha bejelölted a választ, a tovább gomb megnyomásával tudsz a következő kérdésre lépni.</p>

                <input type="submit" class="btnpopup" id="popup" @click="popupHide()"  value="Értem">
            </div>
        </div>
        <img :src="stadaLogo" class="logo-top-left"/>
        <counter :max="maxQuestions" :actual="questionCounter"></counter>
        <div class="category" v-for="(category, categoryIndex, index) in response.data.questions" :key="categoryIndex" v-if="index === activeCategory" :index="index">
            <h3 ><span>{{maxQuestions}}/{{questionCounter}}</span>&nbsp;<div v-html="categoryIndex"></div>&nbsp;-&nbsp;<div v-html="subCategory"></div></h3>
            <question-type v-for="(question,questionIndex, index) in category" :key='questionIndex' :question="question" v-if="activeQuestion == Number(questionIndex)" >
                {{index}}
            </question-type>
            <input type="submit" class="btn" id="next" @click="step()" :class="{active: btnDisabled}" value="Tovább">
        </div>
        <div class="display-none">
            {{timer}}    
        </div>
     </div>
    <div class="is-complete" v-if="isComplete">
            <img :src="stadaLogo" class="logo"/>
            <h2 class="login-title">
                Már kitöltötted a kérdőívet!
            </h2>
            <input type="submit" class="btn" :class="{active: btnDisabled}" @click="logout()" value="Kilépés"/>

    </div>
</div>
</template>

<script>
import questionType from '@/components/question/questionType';
import counter from '@/components/tools/counter';
import stadaLogo from '@/assets/img/stada_logo_cmyk_color.png';
export default {
    data: () => {
        return {
            response : '',
            activeQuestion: Number(0),
            activeCategory: Number(0),
            categoriesSize: 20,
            categories:0,
            stadaLogo,
            questionCounter: 1,
            maxQuestions: 0,
            loaded: false,
            popup: false,
            isComplete: false
        }   
    },
    mounted() {
        this.axios.get('/backend/web/tests?access-token=' + this.$store.state.privateKey).then((response) => {
            if(response.data.isComplete){
                this.isComplete = true;
                this.$store.state.buttonDisabled = true;
            } else {
                this.$store.state.popup = true;
                this.$store.state.session_id = response.data.session_id;
                this.response=response;
                var i = 0;
                var breaked = false;
                for(let key in this.response.data.questions){
                    for (i in this.response.data.questions[key]) {
                        if(this.response.data.questions[key][i]['end_date'] === undefined){
                            break;
                        }
                        
                        if(!breaked) {
                            this.activeQuestion = Number(i);
                        }
                        if(this.response.data.questions[key][i]['end_date'] === null){
                            breaked = true;
                        } 

                        if(!breaked){
                            this.questionCounter++;
                        }
                        if((Number(i) === Number(this.categoriesSize-1)) && !breaked) {
                            this.activeCategory = Number(this.activeCategory + 1);
                        }
                    }
    
                    this.categories++;
                } 
                
                this.maxQuestions = this.categories * this.categoriesSize;

                if(  (Number(this.activeCategory) === Number(this.categoriesSize-1)) && ((Number(this.activeQuestion) === Number(this.categoriesSize-1))  )) {
                    this.$router.push({path: '/thankPage'});
                }

                if(!(Number(this.activeCategory) === 0) || !(Number(this.activeQuestion) === 0) ) {
                    this.$store.state.popup = false;
                }
                this.loaded = true;
            }
        })
  
    },
    computed: {
        popupActive() {
            return this.$store.state.popup;
        },
        subCategory() {
            return this.$store.state.subCategory;
        },
        timer(){
            if(this.$store.state.timer) {
                this.step();
            }
            return this.$store.state.timer;
        },
        btnDisabled(){
            return this.$store.state.buttonDisabled;
        }
    },
    components: {
        'questionType' : questionType,
        'counter' : counter
    },
    methods: {
        popupHide() {
            this.$store.state.popup = false;
        },
        step() {
            var vm = this;
            vm.buttonDisabled = false;
            if( vm.activeQuestion + 1 === vm.categoriesSize){
                vm.activeCategory = vm.activeCategory + 1;
                if(vm.activeCategory === vm.categories) {
                    vm.$router.push({ path: "/thankPage" });
                }
                vm.activeQuestion = 0;
            } else {
                vm.activeQuestion++;
            }

            vm.questionCounter = vm.activeQuestion + (vm.activeCategory * vm.categoriesSize) + 1;
        },
        logout() {
            localStorage.removeItem('stada_private_key');
            this.$store.state.privateKey="";
            this.$router.push({path: "/"});
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.is-complete{
    .logo{
        width: 220px;
        height: 127.5px;
        object-fit: contain;
        margin-top: 150px;
        margin-bottom: 0px;
    }

    h2{
        font-size: 21px;
        color: #4a4a4a;
        margin-top: 61.5px;
        margin-bottom: 31px;
    }
}
.popup{
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;

    .popup-content{
        z-index: 1;
        width: 615px;
        height: 476.5px;
        border-radius: 18.5px;
        background-color: #ffffff;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        padding: 65px;

        p{
            font-size: 23px;
        }

        #popup {
            width: 242.5px;
            position: absolute;
            bottom: 65px;
            margin: 0;
            left:50%;
            transform: translateX(-50%);
            font-family: "Roboto-Regular";
            border: 0px solid transparent;
            border-radius: 48.5px;
            background-image: -webkit-gradient(linear, right top, left top, from(#f577ad), to(#d31567));
            background-image: linear-gradient(to left, #f577ad, #d31567);
            color: white;
            margin-bottom: 0;
        }
    }
}

.display-none{
    display: none;
}
.start-quiz{
    &.hide {
        background-color: red;
    }
}
 .category {
     h3{
         font-size: 18px;
         color: #9b9b9b;
         font-weight: normal;
         span{
            color: #d31567;
         }

         div {
             display: inline-block;
         }
     }
 }
.start-quiz{
    .logo-top-left {
        width: 94px;
        height: 55px;
        object-fit: contain;
        position: absolute;
        top: 62.5px;
        left: 38px;
    }
}

#next {
    position: absolute;
    bottom: 63px;
    left: 50%;
    transform: translateX(-50%);
}

.btn {
    pointer-events: none;

    &.active {
        pointer-events: inherit;
    }
}

</style>
